import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sd_exercise_tag_more",
  "use": "icon-sd_exercise_tag_more-usage",
  "viewBox": "0 0 9 3",
  "content": "<symbol viewBox=\"0 0 9 3\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-sd_exercise_tag_more\">\n<circle cx=\"2\" cy=\"1.5\" r=\"1.5\" fill=\"#B7B7BF\" />\n<circle cx=\"8\" cy=\"1.5\" r=\"1.5\" fill=\"#B7B7BF\" />\n<circle cx=\"14\" cy=\"1.5\" r=\"1.5\" fill=\"#B7B7BF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol